module.exports = __webpack_public_path__ + "static/media/video-bg@2x.daf52d3b.png";